<ct-lib-info-banner>
  <p>
    {{
      (hasPassword()
        ? 'jobboard.platform.settings.password.change-info'
        : 'jobboard.platform.settings.password.set-info'
      ) | transloco
    }}
  </p>
</ct-lib-info-banner>
<form [formGroup]="passwordForm" (submit)="onSubmit()" [attr.data-epoch]="formEpoch()">
  <div class="row">
    @if (hasPassword()) {
      <div
        class="col-12 col-md-4 form-group form-floating"
        [class.invalid]="oldPassword?.invalid && submitAttempt()"
      >
        <input
          type="password"
          class="form-control"
          appPasswordEye
          [placeholder]="'jobboard.platform.settings.password.old' | transloco"
          [formControl]="oldPassword!"
          id="settingsOldPassword"
          autocomplete="current-password"
        />
        <label for="settingsOldPassword">{{
          'jobboard.platform.settings.password.old' | transloco
        }}</label>
        @if (submitAttempt()) {
          <div class="validation">
            @if (oldPassword?.errors?.['required']) {
              <p>{{ 'ct-library.validation.required' | transloco }}</p>
            }
            @if (oldPassword?.errors?.['incorrect']) {
              <p>{{ 'jobboard.platform.settings.password.old-incorrect' | transloco }}</p>
            }
          </div>
        }
      </div>
    }
    <div
      class="col-12 col-md-4 form-group form-floating"
      [class.invalid]="newPassword.invalid && submitAttempt()"
    >
      <input
        type="password"
        class="form-control"
        appPasswordEye
        [placeholder]="'jobboard.platform.settings.password.new' | transloco"
        [formControl]="newPassword"
        id="settingsNewPassword"
        autocomplete="new-password"
      />
      <label for="settingsNewPassword">{{
        'jobboard.platform.settings.password.new' | transloco
      }}</label>
      @if (submitAttempt()) {
        <div class="validation">
          @if (newPassword.errors?.['required']) {
            <p>{{ 'ct-library.validation.required' | transloco }}</p>
          }
          @if (newPassword.errors?.['pattern']) {
            <p>{{ 'ct-library.validation.password-pattern' | transloco }}</p>
          }
        </div>
      }
    </div>
    <div
      class="col-12 col-md-4 form-group form-floating"
      [class.invalid]="(newPasswordConfirm.invalid || passwordForm.errors?.['newPasswordMismatch']) && submitAttempt()"
    >
      <input
        type="password"
        class="form-control"
        appPasswordEye
        [placeholder]="'jobboard.platform.settings.password.new-confirm' | transloco"
        [formControl]="newPasswordConfirm"
        id="settingsNewPasswordConfirm"
        autocomplete="new-password"
      />
      <label for="settingsNewPasswordConfirm">{{
        'jobboard.platform.settings.password.new-confirm' | transloco
      }}</label>
      @if (submitAttempt()) {
        <div class="validation">
          @if (newPasswordConfirm.errors?.['required']) {
            <p>{{ 'ct-library.validation.required' | transloco }}</p>
          }
          @if (passwordForm.errors?.['newPasswordMismatch']) {
            <p>{{ 'ct-library.validation.password-match' | transloco }}</p>
          }
        </div>
      }
    </div>
    <div class="col-12">
      <app-button htmlType="submit" class="mt-3" [loading]="submitting()">
        {{
          (hasPassword()
            ? 'jobboard.platform.settings.password.change-submit'
            : 'jobboard.platform.settings.password.set-submit'
          ) | transloco
        }}
      </app-button>
    </div>
  </div>
</form>
<app-platform-tfa-app-modal
  (submit)="onTfaSubmit($event)"
  #tfaAppModal
></app-platform-tfa-app-modal>
